module.exports = __webpack_public_path__ + "img/rocket-&-planet.f24ec997.png";